"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileshareTaskValidationSchema = void 0;
exports.FileshareTaskValidationSchema = {
    name: 'fileshareTaskValidationSchema',
    properties: {
        zipPath: [
            {
                type: 'isDefined',
            },
        ],
        fileshareOptions: [
            {
                type: 'isNotEmptyObject',
            },
        ],
    },
};
//# sourceMappingURL=fileshare-task-validation-schema.js.map